export default class CancelCurrentAgent {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.currentAgent.clearErrors();
  }
}
